// GO4S — « réutiliser depuis le complexe » (logo / image de couverture).
//
// Un clic sur une vignette ne téléverse rien : il pose le signed_id du blob
// déjà stocké dans le champ caché, et met à jour l'aperçu Alpine du formulaire.
// Le serveur rattache ensuite ce blob existant (voir School#reused_logo=).
//
// Si l'utilisateur choisit ensuite un fichier local, ce choix l'emporte : le
// champ caché est vidé pour que le fichier téléversé gagne côté serveur.
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["field"];

  connect() {
    // Un fichier choisi à la main annule la réutilisation.
    this.onFileChange = () => this.clear();
    this.fileInputs().forEach((input) =>
      input.addEventListener("change", this.onFileChange),
    );
  }

  disconnect() {
    this.fileInputs().forEach((input) =>
      input.removeEventListener("change", this.onFileChange),
    );
  }

  pick({ params, currentTarget }) {
    if (!this.hasFieldTarget) return;

    this.fieldTarget.value = params.signedId;

    // Aperçu immédiat : la vue utilise Alpine (coverPreview / logoPreview).
    const root = this.alpineRoot();
    if (root && params.preview) root[params.preview] = params.url;

    this.element
      .querySelectorAll(".ds-reuse-thumb--active")
      .forEach((el) => el.classList.remove("ds-reuse-thumb--active"));
    currentTarget.classList.add("ds-reuse-thumb--active");
  }

  clear() {
    if (this.hasFieldTarget) this.fieldTarget.value = "";
    this.element
      .querySelectorAll(".ds-reuse-thumb--active")
      .forEach((el) => el.classList.remove("ds-reuse-thumb--active"));
  }

  // Les champs fichier vivent hors de ce contrôleur : on les cherche dans le
  // formulaire, mais UNIQUEMENT celui de la même image. Le formulaire porte
  // logo ET couverture : écouter tous les `input[type=file]` faisait perdre le
  // logo réutilisé dès qu'on téléversait une couverture locale.
  fileInputs() {
    const form = this.element.closest("form");
    if (!form) return [];

    const all = Array.from(form.querySelectorAll('input[type="file"]'));
    if (!this.hasFieldTarget) return all;

    // "school[reused_logo]" -> "school[logo]"
    const own = this.fieldTarget.name.replace("[reused_", "[");
    const mine = all.filter((input) => input.name === own);
    return mine.length ? mine : all;
  }

  alpineRoot() {
    let node = this.element;
    while (node) {
      if (node._x_dataStack || node.__x) {
        return node._x_dataStack ? node._x_dataStack[0] : node.__x.$data;
      }
      node = node.parentElement;
    }
    return null;
  }
}
